import {useSelector} from 'react-redux'

import {selectUser} from 'features/User'

// These are the domains to which we are allowing full CASB rollout (without paywall).
const allowedDomainsForFeatureRollouts = [
  'dope.security',
  'infotechoutreach.onmicrosoft.com',
  'zm6lv.onmicrosoft.com',
  'swgtest.onmicrosoft.com',
  'sanjoydeb.com',
  'pb7q.onmicrosoft.com',
  'valuexpa.onmicrosoft.com',
  'samaatechnologies.com',
  'mellivoratech.co',
  'nextsolutions-global.com',
  'thegrowfi.com',
  'evanssion.com',
  'cloudfactory.dk',
  'boldstart.vc',
  'lsvp.com',
  'prefaceventures.com',
  'leadingedgertng.com',
  'coupa.com',
  'nomadhealth.com',
  'famapr.com',
  'ncovatesolutions.com',
  'plansource.com',
  'leadingedgetrng.com',
  'successacademies.org',
  'it-b.co.uk',
  'spar.net',
  'dolphin.africa',
  'titanwh.com',
  'observa.com',
  'endida.com',
  'infinityx.com.br',
  'archtopfiber.com',
  'paydhealth.com',
  'human.capital',
  'apexsystems.co',
  'toccata-formation.com',
  'brain-networks.fr',
  'onnivation.in',
  'colondon.onmicrosoft.com',
  'spellmanhv.com',
  'afflelou.net',
  'alpineinvestors.onmicrosoft.com',
  'mmimicro.com',
  'spearshield.co.uk',
  'itracium.onmicrosoft.com',
  'itracium.com',
  'b2c2.com',
  'alpha-sense.com',
  'coretocloud.co.uk',
  'outreachhealth.com',
  'mak-system.net',
  'openly.com',
  'getethos.com',
  'goldengatecap.com',
  'fortitude-re.com',
  'rwcm.com',
  'kleinerperkins.com',
  'greathillpartners.com',
  'fortitude-re.com',
  'parthenoncapital.com',
  'havebury.com',
  'cerberus.com',
  'carehospitals.com',
  'firstmark.com',
  'firstround.com',
  'invcg.com',
  'altos.vc',
  'canohealth.com',
  'mitsogo.com',
  'arclightcapital.com',
  'ingramindustries.onmicrosoft.com',
  'monolithicpower.com',
  'imaginepediatrics.org',
  'paul-mccoy.com',
  'luminorgroup.com',
  'kayenta.io',
  'moodmedia.com',
  'profoundresearch.io',
  'postpilot.com'
]

interface useAllowedDomainsCheckReturnType {
  isPaywalled: boolean
}

interface useAllowedDomainsCheckProps {
  showPaywallCheck?: boolean
}

export const useAllowedDomainsCheck = ({
  showPaywallCheck = true,
}: useAllowedDomainsCheckProps = {}): useAllowedDomainsCheckReturnType => {
  const {primaryDomain} = useSelector(selectUser)

  const isPaywalled =
    !allowedDomainsForFeatureRollouts.includes(primaryDomain) &&
    showPaywallCheck

  return {isPaywalled}
}
